import { defaultTheme, type Theme } from '@breetometer/components';

export const lightTheme: Theme = {
	...defaultTheme,
};

export const darkTheme: Theme = {
	...defaultTheme,
};
